/* eslint-disable consistent-return */
/* eslint-disable complexity, react/forbid-component-props, react-hooks/exhaustive-deps, import/no-unassigned-import, sonarjs/cognitive-complexity */
import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext, useState, useRef, useEffect } from 'react';
import ReactCookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import { scroller, animateScroll as scroll, Element } from 'react-scroll';
import {
  HOTEL_URL_PARAMS,
  HOTEL_URL_VALUES,
} from '../../config/constants/google-hotel-ads';
import { PAGE_QUERY } from '../../config/constants/page-types';
import {
  REVIEWS_COMPONENT,
  DROPDOWN_PRODUCT_PAGE,
  SCROLL_INLINE_CALENDAR,
} from '../../config/constants/scroll';
import cookies from '../../config/cookies/cookies';
import {
  BANNER_HIDE_LINK,
  NIBBLE_TIMER,
  NIBBLE_TRACKING_FLAG,
} from '../../config/text/text';
import { trackEvent } from '../../helpers/analytics';
import { getImageIndexForVariant } from '../../helpers/chooseYourOptions';
import {
  getIsOpen,
  getIsPaypalFeatured,
  hidePrice,
  getIsLeadGen,
  isClosedDeal,
  useDealImpresssion,
  displayDealLayoutComponentTravel,
  isDepositDeal,
  isBookingCalendarOnRedemptionDeal,
  isBookingCalendarOnRedemptionGiftDeal,
  getIsChooseYourOptionsDeal,
  getIsChooseYourProductDeal,
} from '../../helpers/deals';
import { getPaymentInstrument } from '../../helpers/klarna';
import { isMobileViewport, useScreenBreakpoint } from '../../helpers/screen';
import {
  mainDealLayoutType,
  getScrollElementDealButtonType,
} from '../../helpers/scroll';
import { parseWowcherPath } from '../../helpers/url';
import { showVideo } from '../../helpers/video';
import ThemeContext from '../../providers/ThemeProvider';
import { fetchLeadingProducts } from '../../redux/actions/bcor';
import { loadCheckoutData } from '../../redux/actions/checkout';
import { getWallet } from '../../redux/actions/wallet';
import MainDealCarousel from './MainDealCarousel';
import MainDealTopMessageBanner from './MainDealTopMessageBanner';
import SoldOutBannerDynamic from './SoldOutBannerDynamic';
import MainDealAdds from './adds/MainDealAdds';
import About from './mainDeal/About';
import Actions from './mainDeal/Actions';
import Title from './mainDeal/Title';
import DealPriceSplat from './shared-components/DealPriceSplat';
import VipExclusiveTag from './shared-components/VipExclusiveTag';
import WishlistIcon from './shared-components/WishlistIcon';
import ChooseYourOptionsDropdown from './shared-components/buy-buttons/ChooseYourOptionsDropdown';
import DealChooseYourOptionsButton from './shared-components/buy-buttons/DealChooseYourOptionsButton';
import MainDealCombinedBuyButton from './shared-components/buy-buttons/MainDealCombinedBuyButton';
import MainDealCombinedGiftButton from './shared-components/buy-buttons/MainDealCombinedGiftButton';
import ReserveButton from './shared-components/buy-buttons/ReserveButton';
import EmptyDeal from './shared-components/emptyDeal';
import 'intersection-observer';
import GiftingButton from './shared-components/gifting-button/GiftingButton';
import GpsrPopup from '../GpsrPopup';
import NibbleAlertPopup from '../nibble/NibbleAlertPopup';
import {
  dealType,
  isNibbleEnabledDealLevel,
  NIBBLE_DWELL_TIME,
} from '../nibble/NibbleHelper';
import { fetchDealExpressPayment } from '../../services/dealGoogleExpressCheckout';

const MainDeal = ({
  isPreview,
  previewMessage,
  showAvailability = true,
  productId,
  setProductPageId,
  isModernVipVariant = false,
  setPdtUrl,
  setFilteredProduct,
}) => {
  const theme = useContext(ThemeContext);
  const router = useRouter();
  const [
    currentDealId,
    deal,
    ssr,
    isAuthenticated,
    userWallet,
  ] = useSelector((state) => [
    state.bcor.currentDealId,
    state.deals.mainDeal,
    state.deals.ssr,
    state.user.isAuthenticated,
    state.wallet.userWallet,
  ]);
  const [isTravel] = useSelector((state) => [state?.checkout?.isTravel]);
  const [isExpressDealPage, setIsExpressDealPage] = useState(false);
  const [isExpressPayLoaded, setIsExpressPayLoaded] = useState(false);
  const [isCheckReady, setIsCheckReady] = useState(true);
  const [isClearpayDeal, setIsClearpayDeal] = useState(false);
  const [isKlarnaDeal, setIsKlarnaDeal] = useState(false);
  const [isKlarnaPayInThree, setIsKlarnaPayInThree] = useState(null);
  const [isPayPalDeal, setIsPayPalDeal] = useState(false);
  const [showProductInfo, setShowProductInfo] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const mainDealPrice = deal?.price;
  const isCountryGb = process.env.NEXT_PUBLIC_COUNTRY_CODE === 'gb';
  const userBalance =
    userWallet[isCountryGb ? 0 : 1]?.balanceWithValidExperienceCredit;
  const isNationalDeal = router?.query?.slug[0] === 'shop';
  const isChooseYourOptions = getIsChooseYourOptionsDeal(deal);
  const isChooseYourProductDeal = getIsChooseYourProductDeal(deal);

  // difference between mainDealPrice and creditBal
  const differenceCreditAmount = userBalance - mainDealPrice;

  const breakpoint = useScreenBreakpoint();
  const bt = ReactCookies.load(cookies.basketToken);
  const docc = ReactCookies.load(cookies.docc);
  const [isMobile, setIsMobile] = useState(false);
  const dispatch = useDispatch();
  const isVipUser = useSelector((state) => state?.user?.userprofile?.vipUser);
  // This state is maintained to prevent the broken image bug on main deal page.
  const [selectedOption, setSelectedOption] = useState(-1);
  const [showEmptyMessage, setShowEmptyMessage] = useState(false);
  const [nibbleAlertPopup, setNibbleAlertPopup] = useState(false);
  const [showNibble, setShowNibble] = useState(false);
  const [isNibbleAppeared, setIsNibbleAppeared] = useState(false);
  const [isCYOSelected, setIsCYOSelected] = useState(false);
  const didTrackNibble = useRef(false);
  const hasTracked = useRef(false);
  const didTrackNibblePromtClick = useRef(false);

  const showVipExclusiveTag = deal?.display?.vipExclusive;

  const filteredProduct = deal?.products?.filter(
    (product) => product.id === Number.parseInt(productId),
  );
  const rowId = filteredProduct
    ? isChooseYourProductDeal
      ? filteredProduct[0]?.id
      : filteredProduct[0]?.rowId
    : 0;
  const columnId = filteredProduct ? filteredProduct[0]?.columnId : 0;
  const [rowSelection, setRowSelection] = useState(rowId); // 1st option
  const [columnSelection, setColumnSelection] = useState(columnId); // 2nd Option (hidden if only 1 option)
  const initialImageIndex = getImageIndexForVariant(
    deal,
    rowSelection,
    columnSelection,
    productId,
    isChooseYourProductDeal,
  );
  const [imageVariantIndex, setImageVariantIndex] = useState(initialImageIndex);
  const [productStatus, setProductStatus] = useState(() => {
    const foundProduct = deal?.products?.find((item) => item?.id === productId);

    return foundProduct ? foundProduct?.soldOut : null;
  });

  useEffect(() => {
    if (showVipExclusiveTag) {
      trackEvent('viphub: exclusive click');
      trackEvent('viphub: exclusive visit');
    }
  }, []);

  useEffect(() => {
    if (
      deal &&
      (isBookingCalendarOnRedemptionDeal(deal) ||
        isBookingCalendarOnRedemptionGiftDeal(deal))
    ) {
      dispatch(fetchLeadingProducts(deal, currentDealId));
    }
  }, [deal]);

  useEffect(() => {
    setIsMobile(isMobileViewport());
  }, [breakpoint]);

  useEffect(() => {
    dispatch(loadCheckoutData(bt));
    dispatch(getWallet());
    localStorage.removeItem(NIBBLE_TIMER);
  }, []);

  const [isSoldOutExpand, setIsSoldOutExpand] = useState(false);
  const isEvergreen = router.query.slug.includes('e');
  const [finePrintCollapsed, setFinePrintCollapsed] = useState(false);
  const [reviewsCollapsed, setReviewsCollapsed] = useState(true);
  const [amenitiesCollapsed, setAmenitiesCollapsed] = useState(true);
  const [selectedOptions, setSelectedOptions] = useState(() => {
    if (deal && deal.products && deal.products.length) {
      return new Array(deal.products.length).fill(0);
    } else {
      return [];
    }
  });
  const [showMultiError, setShowMultiError] = useState(false);
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const buyButtonRef = useRef(null);
  const viewAvailabilityButtonRef = useRef();
  const giftButtonRef = useRef(null);
  const quickBuyButtonRef = useRef(null);
  const location = useSelector((state) => state.locations.location.shortName);
  const locationStore = useSelector((state) => state.locations);
  const componentRef = useRef(null);
  useDealImpresssion({ componentRef, dealId: deal?.id, location });
  const isProductPage =
    isNationalDeal &&
    (isChooseYourOptions || isChooseYourProductDeal) &&
    !isEvergreen &&
    Boolean(productId);

  const isSoldOut = isProductPage
    ? productStatus
    : isClosedDeal(deal, router.query, router.pathname, isPreview, productId);

  useEffect(() => {
    if (isSoldOut && !isProductPage) return;
    const getKlarnaInfo = async () => {
      const instruments = await getPaymentInstrument(deal.id);
      setIsKlarnaDeal(
        Boolean(instruments?.find((item) => item?.type === 'klarna')),
      );
      setIsKlarnaPayInThree(
        Boolean(instruments?.find((item) => item?.details?.po === 'p3')),
      );
      setIsPayPalDeal(
        Boolean(instruments?.find((item) => item?.type === 'paypal')),
      );
      setIsClearpayDeal(
        Boolean(instruments?.find((item) => item?.type === 'clearpay')),
      );
    };
    getKlarnaInfo();
  }, [deal.id, isSoldOut]);

  useEffect(() => {
    if (
      selectedOptions.some((option) => option > 0) ||
      isOptionSelected ||
      isCYOSelected ||
      isSoldOut
    ) {
      setNibbleAlertPopup(false);

      return;
    }

    if (!nibbleAlertPopup) {
      const nibbleTimeout = setTimeout(() => {
        if (
          dealType(deal) !== null &&
          isNibbleEnabledDealLevel(deal, isVipUser, true) &&
          !didTrackNibble.current
        ) {
          trackEvent('nibble_product_selection_would_have_loaded');
          localStorage.setItem(NIBBLE_TIMER, true);
          didTrackNibble.current = true;
        }

        if (
          dealType(deal) !== null &&
          isNibbleEnabledDealLevel(deal, isVipUser)
        ) {
          setNibbleAlertPopup(true);
          trackEvent('nibble_product_selection_appear');
        }
      }, NIBBLE_DWELL_TIME);

      return () => clearTimeout(nibbleTimeout);
    }
  }, [selectedOptions, isOptionSelected, isSoldOut, isCYOSelected, deal]);

  if (!deal || Object.keys(deal).length === 0)
    return <EmptyDeal isPreview={isPreview} previewMessage={previewMessage} />;

  const dealTitle = isVipUser && deal?.vipTitle ? deal?.vipTitle : deal?.title;
  const dealHeadline =
    isVipUser && deal?.vipHeadline ? deal?.vipHeadline : deal?.headline;
  const title = deal.title ? hidePrice(dealTitle) : '';
  const headline = deal.headline ? hidePrice(dealHeadline) : '';
  const isPaypalFeatured = getIsPaypalFeatured(deal);
  const isOpen = getIsOpen(deal, router.query);
  const isLeadGen = getIsLeadGen(deal);
  const hasVideo = showVideo(deal);
  const { details, searchParams } = parseWowcherPath(router.asPath);
  const isClaim =
    Boolean(searchParams.get(PAGE_QUERY.claimMyGift)) && isAuthenticated;
  const isExperienceBox = deal.display.experienceGiftBox;

  const adProductId = searchParams.get(HOTEL_URL_PARAMS.product_id);
  const utmMedium = searchParams.get(HOTEL_URL_PARAMS.utm_medium);
  const isHotelAd =
    utmMedium === HOTEL_URL_VALUES.utm_medium_free ||
    utmMedium === HOTEL_URL_VALUES.utm_medium_paid;
  const isGoogleHotel = Boolean(adProductId && isHotelAd);

  useEffect(async () => {
    // Make API call for payment instruments
    if (!isSoldOut && docc === 'b') {
      const response = await fetchDealExpressPayment(deal?.id);
      if (response?.data?.paymentInstruments?.length > 0) {
        setPaymentData(response?.data?.paymentInstruments);
        setIsExpressDealPage(true);
      }
      setIsCheckReady(false);
    } else {
      setIsCheckReady(false);
    }
  }, []);

  const hideDeal = (event) => {
    event.preventDefault();
    scroll.scrollToTop();
    setIsSoldOutExpand(false);
  };

  const toReviews = () => {
    scroller.scrollTo(REVIEWS_COMPONENT, {
      delay: 100,
      duration: 1_000,
      offset: breakpoint === 'sm' ? -120 : 0,
      smooth: true,
    });
    setReviewsCollapsed(false);
  };

  //  The products need to be ordained by price, cheapest first
  if (deal.products) {
    deal.products.sort((a, b) =>
      a.price > b.price ? 1 : a.price < b.price ? -1 : 0,
    );
  }

  const mainDealGiftingChooseYourOptionsButton = (
    isTypeMobile,
    targetScroll,
    pageDetails,
    onlyGift,
  ) => {
    if (isSoldOut && !isProductPage) return;

    return (
      <>
        <DealChooseYourOptionsButton
          className={'gifting'}
          compact={false}
          deal={deal}
          isModernVipVariant={isModernVipVariant}
          isOptionSelected={isOptionSelected}
          isTypeMobile={isTypeMobile}
          onlyGift={onlyGift}
          pageDetails={pageDetails}
          targetScroll={targetScroll}
        />
      </>
    );
  };
  const mainDealGiftButton = (
    isTypeMobile,
    targetScroll,
    pageDetails,
    modalButton,
  ) => {
    if (isSoldOut && !isProductPage) return;

    return (
      <>
        <div className={`gift-button ${isTypeMobile ? 'hide-desktop' : ''}`}>
          {displayDealLayoutComponentTravel(
            'MainDealCombinedGiftButton',
            deal,
            pageDetails,
            isTypeMobile,
          ) && (
            <>
              <MainDealCombinedGiftButton
                className={`${
                  isExpressDealPage && isExpressPayLoaded
                    ? `full-width outline margin express-gifting-text ${
                        isNibbleAppeared ? 'top-margin' : ''
                      }`
                    : modalButton
                    ? 'gifting'
                    : 'full-width outline margin'
                }`}
                deal={deal}
                isClaim={isClaim}
                isGoogleHotel={isGoogleHotel}
                isProductPage={isProductPage}
                isSoldOut={isSoldOut}
                isTypeMobile={isTypeMobile}
                onSetShowMultiError={(show) => setShowMultiError(show)}
                position={selectedOption}
                searchParams={searchParams}
                selectedOptions={selectedOptions}
                targetScroll={targetScroll}
              />
            </>
          )}
        </div>
      </>
    );
  };

  const mainDealBuyButton = (isTypeMobile, targetScroll, pageDetails) => {
    if (isExperienceBox) return null;
    if (isClaim) deal.giftClaim = true;
    if (targetScroll === 'ChooseYourOptions' && isClaim) return null;

    const handleNibbleAlertButton = () => {
      trackEvent('nibble_product_selection_click');
      setNibbleAlertPopup(false);
      localStorage.setItem(NIBBLE_TIMER, true);
      localStorage.setItem(NIBBLE_TRACKING_FLAG, true);
      if (dealType(deal) !== null) {
        buyButtonRef?.current?.click();
      }
      if (isMobile && details.isTravel) {
        if (viewAvailabilityButtonRef.current) {
          viewAvailabilityButtonRef.current.clickPrimaryButton();
        }
      } else if (details.isTravel) {
        scroller.scrollTo(SCROLL_INLINE_CALENDAR, {
          delay: 100,
          duration: 1_000,
          smooth: true,
        });
      }

      setTimeout(() => {
        localStorage.removeItem(NIBBLE_TRACKING_FLAG);
      }, 2_000);
    };

    return (
      <>
        {nibbleAlertPopup && (
          <NibbleAlertPopup
            deal={deal}
            onButtonClick={handleNibbleAlertButton}
            setNibbleAlertPopup={() => setNibbleAlertPopup()}
          />
        )}
        <MainDealCombinedBuyButton
          buttonRef={
            isTypeMobile || details.isTravel ? buyButtonRef : undefined
          }
          className={classNames('deal-main-deal__buy full-width margin', {
            'size-xlarge': Boolean(details.isTravel),
          })}
          columnSelection={columnSelection}
          deal={deal}
          didTrackNibble={didTrackNibble}
          didTrackNibblePromtClick={didTrackNibblePromtClick}
          differenceCreditAmount={differenceCreditAmount}
          hasTracked={hasTracked}
          isCheckReady={isCheckReady}
          isClaim={isClaim}
          isExpressDealPage={isExpressDealPage && isMobile}
          isExpressPayLoaded={isExpressPayLoaded}
          isGoogleHotel={isGoogleHotel}
          isModernVipVariant={isModernVipVariant}
          isNibbleAppeared={isNibbleAppeared}
          isOptionSelected={isOptionSelected}
          isProductPage={isProductPage}
          isSoldOut={isSoldOut}
          isTypeMobile={isTypeMobile}
          mainDealGiftButton={mainDealGiftButton(
            isTypeMobile,
            targetScroll,
            pageDetails,
          )}
          onSetShowMultiError={(show) => setShowMultiError(show)}
          pageDetails={details}
          paymentData={paymentData}
          position={selectedOption}
          quickBuyButtonRef={quickBuyButtonRef}
          rowSelection={rowSelection}
          searchParams={searchParams}
          selectedOptions={selectedOptions}
          setIsCYOSelected={setIsCYOSelected}
          setIsExpressPayLoaded={setIsExpressPayLoaded}
          setIsNibbleAppeared={setIsNibbleAppeared}
          setShowEmptyMessage={setShowEmptyMessage}
          targetScroll={targetScroll}
          viewAvailabilityButtonRef={viewAvailabilityButtonRef}
        />
      </>
    );
  };

  // combination of all variations of buy and gift button type
  const getButtons = (resolution, pageDetails, targetScroll = null) => {
    const isTypeMobile = resolution === 'mobile';

    if (isExperienceBox) {
      return (
        <div
          className={`deal-main-deal__buy ${
            isTypeMobile ? 'hide-desktop' : ''
          }`}
        >
          <MainDealCombinedGiftButton
            buttonRef={
              isTypeMobile || details.isTravel ? giftButtonRef : undefined
            }
            className="full-width margin size-xlarge"
            deal={deal}
            isExperienceBox={isExperienceBox}
            isTypeMobile={isTypeMobile}
            onSetShowMultiError={(show) => setShowMultiError(show)}
            selectedOptions={selectedOptions}
            targetScroll={targetScroll}
          />
        </div>
      );
    }

    return <>{mainDealBuyButton(isTypeMobile, targetScroll, pageDetails)}</>;
  };

  const getGiftingButton = (resolution, targetScroll = null, pageDetails) => {
    const isTypeMobile = resolution === 'mobile';
    if (isClaim) return null;

    return (
      <GiftingButton
        columnSelection={columnSelection}
        deal={deal}
        isEvergreen={isEvergreen}
        isMobile={isTypeMobile}
        isProductPage={isProductPage}
        isSoldOut={isSoldOut}
        mainDealGiftButton={mainDealGiftButton(
          isTypeMobile,
          targetScroll,
          pageDetails,
          true,
        )}
        mainDealGiftingChooseYourOptionsButton={mainDealGiftingChooseYourOptionsButton(
          isTypeMobile,
          targetScroll,
          pageDetails,
          true,
        )}
        onSetShowMultiError={(show) => setShowMultiError(show)}
        position={selectedOption}
        rowSelection={rowSelection}
        selectedOptions={selectedOptions}
        setShowEmptyMessage={setShowEmptyMessage}
        targetScroll={targetScroll}
      />
    );
  };

  const mainDealCarouselOnClick = () => {
    if (!details.isTravel || isMobile) {
      if (isExperienceBox) {
        giftButtonRef?.current.click();
      } else {
        buyButtonRef.current.click();
      }
    } else if (details.isTravel) {
      scroller.scrollTo(
        getScrollElementDealButtonType(deal, mainDealLayoutType.actions),
        {
          delay: 100,
          duration: 1_000,
          smooth: true,
        },
      );
    }
  };

  const reviewScore = deal.reviewSummary?.average || null;
  const reviewCount = deal.reviewSummary?.total || null;

  return (
    <>
      <div
        className={classNames('deal-main-deal', {
          'deal-main-deal__sold': isSoldOut,
          'deal-main-deal__sold--expand': isSoldOutExpand,
          'deal-main-deal--has-video': hasVideo,
        })}
        data-deal-id={deal.id}
        data-review-count={reviewCount}
        data-review-score={reviewScore}
      >
        {isPreview && <MainDealTopMessageBanner message={previewMessage} />}
        <div className={`deal-main-deal__card`}>
          <div
            className={isProductPage ? 'deal-main-deal__headercontainer' : ''}
          >
            <Title
              display={!details.isTravel}
              headline={headline}
              isProductPage={isProductPage}
              title={title}
            />
          </div>

          <div className="deal-main-deal__image" ref={componentRef}>
            {!isMobile && !isClaim && (
              <DealPriceSplat
                className={
                  isModernVipVariant && !isVipUser ? 'new-variant-full' : 'full'
                }
                coinFlipAnimation
                columnSelection={columnSelection}
                deal={deal}
                forcePrice
                isGoogleHotel={isGoogleHotel}
                isHideIfNoDiscount={false}
                isModernVipVariant={isModernVipVariant && !isVipUser}
                isProductPage={isProductPage}
                isTravel={details.isTravel}
                rowSelection={rowSelection}
                visible={!ssr}
              />
            )}
            {showVipExclusiveTag ? (
              <VipExclusiveTag isTravelDeal={details.isTravel} />
            ) : null}
            <MainDealAdds adverts={deal?.travelAdsList} />
            <MainDealCarousel
              deal={deal}
              disableClickAction={isLeadGen}
              imageVariantIndex={imageVariantIndex}
              isClosed={!isOpen}
              isProductPage={isProductPage}
              onClick={mainDealCarouselOnClick}
            />
            {isMobile && (
              <ReserveButton
                buttonRef={buyButtonRef}
                deal={deal}
                extraClasses={classNames('main reserve-button outline margin', {
                  'size-small': true,
                })}
              />
            )}
            <WishlistIcon dealId={deal.id} />
          </div>
          <div>
            {isProductPage && (
              <div className="deal-choose-your-options__dropdown">
                <Element name={DROPDOWN_PRODUCT_PAGE} />
                <ChooseYourOptionsDropdown
                  columnSelection={columnSelection}
                  deal={deal}
                  isChooseYourProductDeal={isChooseYourProductDeal}
                  isMobile={isMobile}
                  isModernVipVariant={isModernVipVariant && !isVipUser}
                  productId={productId}
                  rowSelection={rowSelection}
                  selectedOption={selectedOption}
                  setColumnSelection={setColumnSelection}
                  setFilteredProduct={setFilteredProduct}
                  setImageVariantIndex={setImageVariantIndex}
                  setIsOptionSelected={setIsOptionSelected}
                  setPdtUrl={setPdtUrl}
                  setProductPageId={setProductPageId}
                  setProductStatus={setProductStatus}
                  setRowSelection={setRowSelection}
                  setSelectedOption={setSelectedOption}
                  setShowEmptyMessage={setShowEmptyMessage}
                  showEmptyMessage={showEmptyMessage}
                />
              </div>
            )}
            <div className="deal-main-deal__content">
              <About
                amenitiesCollapsed={amenitiesCollapsed}
                columnSelection={columnSelection}
                deal={deal}
                details={details}
                dynamicPricingReady={!ssr}
                finePrintCollapsed={finePrintCollapsed}
                getButtons={getButtons}
                getGiftingButton={getGiftingButton}
                headline={headline}
                isClaim={isClaim}
                isClearpayDeal={isClearpayDeal}
                isExperienceBox={isExperienceBox}
                isGoogleHotel={isGoogleHotel}
                isKlarnaDeal={isKlarnaDeal}
                isKlarnaPayInThree={isKlarnaPayInThree}
                isMobile={isMobile}
                isModernVipVariant={isModernVipVariant && !isVipUser}
                isPayPalDeal={isPayPalDeal}
                isProductPage={isProductPage}
                pageDetails={details}
                position={selectedOption}
                reviewsCollapsed={reviewsCollapsed}
                rowSelection={rowSelection}
                selectedOptions={selectedOptions}
                setAmenitiesCollapsed={setAmenitiesCollapsed}
                setColumnSelection={setColumnSelection}
                setFinePrintCollapsed={setFinePrintCollapsed}
                setReviewsCollapsed={setReviewsCollapsed}
                setRowSelection={setRowSelection}
                setSelectedOptions={setSelectedOptions}
                setShowMultiError={setShowMultiError}
                setShowProductInfo={setShowProductInfo}
                showAvailability={showAvailability}
                showMultiError={showMultiError}
                title={title}
                toReviews={toReviews}
              />
              {!isMobile && (
                <Actions
                  buttonRef={buyButtonRef}
                  deal={deal}
                  getButtons={getButtons}
                  getGiftingButton={getGiftingButton}
                  isClaim={isClaim}
                  isClearpayDeal={isClearpayDeal}
                  isEvergreen={isEvergreen}
                  isExperienceBox={isExperienceBox}
                  isGoogleHotel={isGoogleHotel}
                  isKlarnaDeal={isKlarnaDeal}
                  isKlarnaPayInThree={isKlarnaPayInThree}
                  isLeadGen={isLeadGen}
                  isModernVipVariant={isModernVipVariant && !isVipUser}
                  isOptionSelected={isOptionSelected}
                  isPayPalDeal={isPayPalDeal}
                  isPaypalFeatured={isPaypalFeatured}
                  isSoldOut={isSoldOut}
                  mainDealBuyButton={mainDealBuyButton}
                  pageDetails={details}
                  searchParams={searchParams}
                  selectedOption={selectedOption}
                  selectedOptions={selectedOptions}
                  setIsCYOSelected={setIsCYOSelected}
                  setIsOptionSelected={setIsOptionSelected}
                  setSelectedOptions={setSelectedOptions}
                  setShowEmptyMessage={setShowEmptyMessage}
                  setShowMultiError={setShowMultiError}
                  setShowProductInfo={setShowProductInfo}
                  showEmptyMessage={showEmptyMessage}
                  showMultiError={showMultiError}
                  theme={theme}
                  toReviews={toReviews}
                />
              )}
            </div>
          </div>
          {isSoldOut && !isProductPage && (
            <div className="deal-main-deal__hide-link">
              <Link href="#">
                <a
                  className="banner__link banner__link--bottom"
                  onClick={hideDeal}
                  onKeyDown={hideDeal}
                  role="link"
                  tabIndex={0}
                >
                  {BANNER_HIDE_LINK}
                </a>
              </Link>
            </div>
          )}

          {isSoldOut && (
            <SoldOutBannerDynamic
              dailyPurchaseCapReached={deal.dailyPurchaseCapReached}
              id={deal.id}
              isExpand={setIsSoldOutExpand}
              isProductPage={isProductPage}
              products={deal.products}
              weeklyPurchaseCapReached={deal.weeklyPurchaseCapReached}
            />
          )}
        </div>
      </div>
      {showProductInfo && (
        <GpsrPopup
          deal={deal}
          setShowProductInfo={setShowProductInfo}
          showProductInfo={showProductInfo}
        />
      )}
      <style jsx>{`
        .deal-main-deal {
          display: flex;
          flex-direction: column;
          position: relative;
          width: 100%;
        }
        .deal-main-deal__card {
          margin: 0;
          padding: 0;
          text-align: left;
          color: inherit;
          text-decoration: none;
          border-radius: 10px;
          transition: color 0.15s ease, border-color 0.15s ease;
          position: relative;
          background-color: ${theme.colors.dealbackgroundcolor};
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
          display: flex;
          flex-direction: column;
        }
        .deal-choose-your-options__dropdown {
          margin-top: -8px;
          margin-right: 8px;
          margin-left: 8px;
          margin-bottom: -20px;
        }
        .deal-main-deal__subtitle {
          visibility: hidden;
        }
        .deal-main-deal__subtitle.visible {
          visibility: visible;
        }
        .deal-main-deal__image {
          position: relative;
        }
        .deal-main-deal__content {
          position: relative;
          display: flex;
          align-items: flex-start;
        }
        .deal-main-deal__hide-link {
          padding: 20px 16px 16px;
          text-align: right;
        }
        .deal-main-deal__social-cues {
          margin-bottom: 20px;
        }
        .deal-main-deal__social-cues--side {
          padding: 0 8px;
          margin-bottom: 8px;
        }

        .deal-main-deal__sold {
          color: ${!isProductPage ? theme.commoncolors.greylighter : ''};
          position: relative;
        }

        .deal-main-deal__sold
          .deal-main-deal__card
          .deal-main-deal__headercontainer {
          color: ${theme.commoncolors.greyshadelighter};
        }

        .deal-main-deal__sold .deal-main-deal__card {
          height: ${isProductPage ? 'auto' : '309px'};
          overflow: hidden;
        }

        .deal-main-deal__sold.deal-main-deal__sold--expand
          .deal-main-deal__card {
          height: auto;
        }

        .deal-main-deal__sold .deal-main-deal__image:after {
          content: '';
          background: ${theme.commoncolors.greycharcoal};
          position: absolute;
          top: 0;
          bottom: 0;
          width: 100%;
          opacity: 0.7;
          z-index: 999;
        }
        :global(.deal-main-deal .splat.full) {
          position: absolute;
          bottom: 50px;
          right: 11px;
        }

        :global(.main-deal-travel .deal-main-deal .splat.full) {
          right: 48px;
          bottom: 132px;
        }

        :global(.deal-main-deal--has-video .splat.full) {
          pointer-events: none;
          bottom: 66px;
        }
        :global(.deal-main-deal--has-video .thumbs) {
          bottom: 68px;
        }
        :global(.deal-main-deal .control-dots) {
          position: absolute;
          bottom: 0;
          margin: 10px 0;
          pointer-events: none;
        }
        :global(.deal-main-deal .carousel__image--single) {
          width: 100%;
        }
        :global(.gift-button .primary-button) {
          white-space: nowrap;
        }

        :global(.main-deal-travel .vip-exclusive-tag) {
          bottom: 10px;
          right: 10px;
        }
        :global(.main-deal-travel .exclusive-img) {
          width: 160px;
        }

        @media (max-width: ${theme.breakpoints.xlDown}) {
          .deal-main-deal {
            margin-bottom: 20px;
          }
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .deal-main-deal__content {
            flex-direction: column;
          }
          .deal-main-deal__hide-link {
            padding-bottom: 0;
          }

          .deal-main-deal__subtitle {
            margin-bottom: 16px;
          }
          .deal-main-deal__admin-section {
            display: flex;
            flex-direction: column;
          }
          :global(.deal-main-deal .hide-mobile) {
            display: none;
          }
          :global(.deal-main-deal .bought-count) {
            position: absolute;
            bottom: 10px;
            background-color: transparent !important;
            color: white !important;
          }
          :global(.deal-main-deal .thumbs) {
            display: none;
          }
          :global(.deal-main-deal .social-cues-container__main-image__bottom) {
            display: none;
          }
          :global(.deal-main-deal .splat__original-price-wrapper) {
            display: none;
          }

          /* flip the order on mobile*/
          :global(.deal-main-deal__admin-section .terms) {
            order: 1;
          }
          :global(.deal-main-deal__admin-section #reviews) {
            order: 2;
          }
          :global(.deal-main-deal__admin-section .redeem) {
            order: 3;
          }

          .deal-main-deal__sold .deal-main-deal__card {
            height: ${isProductPage ? 'auto' : '225px'};
            overflow: ${isProductPage ? 'inherit' : 'hidden'};
          }
          .deal-main-deal__sold .seo-nav-container--mobile-only {
            display: none;
          }
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          :global(.maindeal-combined-button.sticky-button) {
            position: sticky;
            bottom: 0px;
            z-index: 1001;
            background-color: ${isMobile && isExpressPayLoaded
              ? '#ffffff'
              : ''};
          }
          :global(.maindeal-combined-button .buy-button button),
          :global(.maindeal-combined-button.buy-button button) {
            font-size: 18px;
            border-radius: 40px;
          }
          :global(.maindeal-combined-button .gift-button button) {
            margin-bottom: 0;
            margin-top: ${isMobile ? '4px' : '8px'};
            min-height: unset;
          }
          .deal-main-deal {
            margin-bottom: 5px;
          }
          .deal-main-deal__card {
            border-radius: 0;
            box-shadow: none;
          }
          :global(.deal-main-deal__breadcrumbs.breadcrumb-container) {
            margin-top: 16px;
            order: 5;
          }
          :global(.wishlist-icon .message-container) {
            ${isDepositDeal(deal) && 'width: 200px;'}
          }
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          :global(.deal-main-deal .hide-desktop) {
            display: none;
          }
          :global(.main-deal-travel .vip-exclusive-tag) {
            bottom: 90px;
            left: 10px;
          }
          .deal-choose-your-options__dropdown {
            margin-bottom: -12px;
          }
        }
        @media (min-width: ${theme.breakpoints.lgUp}) {
          :global(.main-deal-travel .vip-exclusive-tag) {
            bottom: 100px;
            left: 10px;
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          :global(.main-deal-travel .deal-main-deal .splat.full) {
            bottom: 54px;
          }
        }
      `}</style>
    </>
  );
};

MainDeal.propTypes = {
  isModernVipVariant: PropTypes.bool,
  isPreview: PropTypes.bool,
  previewMessage: PropTypes.string,
  productId: PropTypes.string,
  showAvailability: PropTypes.bool,
};

MainDeal.defaultProps = {
  isPreview: false,
  previewMessage: '',
};

export default MainDeal;
